import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState: {
  open: boolean;
  /** Text to prefill the composer with when opened from elsewhere (e.g. "Set it up for me") */
  initialPrompt: string | null;
} = {
  open: false,
  initialPrompt: null,
};

const assistantDrawerSlice = createSlice({
  name: `assistantDrawer`,
  initialState,
  reducers: {
    open(state, action: PayloadAction<string | undefined>) {
      state.open = true;
      state.initialPrompt = action.payload ?? null;
    },
    close(state) {
      state.open = false;
      state.initialPrompt = null;
    },
    clearInitialPrompt(state) {
      state.initialPrompt = null;
    },
  },
});

export const { open, close, clearInitialPrompt } = assistantDrawerSlice.actions;

export const assistantDrawerReducer = assistantDrawerSlice.reducer;
